/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
import toastr from 'toastr';
import { ls } from '../LocalStorage';
import Authorization from '../Authorization';
import Env from '../env';

let isRefreshingToken = false;

const handleTokenRefresh = data => {
  const AUTH_USER = JSON.parse(ls.getItem('auth_user'));
  const ACCESS_TOKEN = `Bearer ${data.access_token}`;
  ls.setItem(
    'auth_user',
    JSON.stringify({ ...AUTH_USER, token: ACCESS_TOKEN })
  );
  ls.removeItem('expires_on');
  ls.setItem('expires_on', data.expires_on);
  Authorization.setAccessToken(ACCESS_TOKEN);
  Authorization.setAuthUser();

  return ACCESS_TOKEN;
};

const refreshedAccessToken = async () => {
  const refreshToken = ls.getItem('refresh_token');
  const body = {
    client_id: `${Env.env.REACT_APP_IAM_CLIENT_ID}`,
    redirect_uri: `${Env.env.REACT_APP_IAM_REDIRECT_URI}`,
    scope: `${Env.env.REACT_APP_IAM_SCOPE}`,
    grant_type: `${Env.env.REACT_APP_IAM_REFRESH_GRANT_TYPE}`,
    code_verifier: `${Env.env.REACT_APP_IAM_CODE_VERIFIER}`,
    refresh_token: refreshToken,
  };
  try {
    const response = await fetch(`${Env.env.REACT_APP_IAM_BASE_URL}/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(body).toString(), // Convert data to URLSearchParams
    });
    if (response.status === 200) {
      const data = await response.json();
      const newToken = handleTokenRefresh(data);

      return { ok: true, accessToken: newToken };
    }

    return { ok: false };
  } catch (error) {
    console.error('Error:', error);

    return { ok: false };
  }
};

export const fetchData = async (url, config) => {
  try {
    const accessToken = Authorization.getAccessToken();
    const newConfig = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: accessToken,
        key: Env.env.REACT_APP_API_KEY,
      },
    };

    let response = await fetch(url, newConfig);
    const tokenExpirationTime = ls.getItem('expires_on') * 1 * 1000;

    if (
      response
      && response.status === 401
      && Date.now() > tokenExpirationTime
    ) {
      if (!isRefreshingToken) {
        isRefreshingToken = true;
        const refreshResponse = await refreshedAccessToken();
        isRefreshingToken = false;

        if (refreshResponse.ok) {
          const userId = localStorage.getItem(
            'csSupportRequestedLoggedInUserId'
          );
          const userRoleSupport = localStorage.getItem(
            'csSupportRequestedLoggedInRole'
          );
          const getCdsRequestByProfile = localStorage.getItem('cdsRequests');
          const getProflieBystatus = localStorage.getItem('profStatus');
          const userRole = Authorization.getAuthUserRole();
          let newConfig;
          if (userRole === 'CSSUPPORT') {
            newConfig = {
              ...config,
              headers: {
                ...config.headers,
                Authorization: refreshResponse.accessToken,
                csSupportRequestedLoggedInUserId: `${userId}`,
                csSupportRequestedLoggedInRole: `${userRoleSupport}`,
                'Content-Type': 'application/json',
              },
            };
          } else if (getCdsRequestByProfile) {
            newConfig = {
              ...config,
              headers: {
                ...config.headers,
                Authorization: refreshResponse.accessToken,
                cdsUserId: `${Authorization.getAuthUserId()}`,
                profileStatus: `${getProflieBystatus}`,
                'Content-Type': 'application/json',
              },
            };
          } else {
            newConfig = {
              ...config,
              headers: {
                ...config.headers,
                Authorization: refreshResponse.accessToken,
                'Content-Type': 'application/json',
              },
            };
          }
          // eslint-disable-next-line no-param-reassign
          //  config.headers.Authorization = refreshResponse.accessToken;
          response = await fetch(url, newConfig);
        } else {
          toastr.error('Session has expired, please login again');
          Authorization.logout();

          return;
        }
      }
    }

    if (response.status === 417) {
      // eslint-disable-next-line consistent-return
      return response;
    }

    if (!response.ok) {
      // toastr.error(response.statusText || 'Something went wrong');

      return response;
    }

    // eslint-disable-next-line consistent-return
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('error', error.message);
  }
};
